export default __webpack_public_path__ + "static/media/west_r.eb905312.jpg";